import api from '@api/Api';

export default {

    getPlans() {
        return api().get(`billing/plans`);
    },

    getPrices(id) {
        return api().get(`billing/prices/${id}`);
    },

    getCoupon(code) {
        return api().get(`billing/coupons/${code}`);
    },

}
